import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Row } from 'reactstrap';

interface IProps {
    anchorLinks: AnchorLink[],
    children?: React.ReactNode
}

export interface AnchorLink {
    displayName: string,
    hashLocation: string
}

export const PageAnchors =  (props: IProps) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = async () => {
        setDropdownOpen(state => !state);
    }

    return (
        <div className="pageAnchorsBody">
            <Row className="pageAnchorsSection desktopView">
                <Col sm={8} className="inPageNav" >
                    <ul>
                        {props.anchorLinks.map((anchor, index) => {
                            return (
                                <li key={index} className="jumpLink">
                                    <HashLink smooth to={anchor.hashLocation} className="iconDownArrowBlue buttonAsLink">{anchor.displayName}</HashLink>
                                </li>
                            )
                        })}
                    </ul>
                </Col>
                {props.children}
            </Row>
            <Row className="pageAnchorsSection mobileView">
                <Col sm={8} className="inPageNav" >
                    <Dropdown id="pageAnchorsDropDown" className="pageAnchorsDropDown" direction="down" isOpen={dropdownOpen} toggle={toggleDropdown}>
                        <DropdownToggle caret>
                            Jump to...&nbsp;
                        </DropdownToggle>
                        <DropdownMenu>
                            {props.anchorLinks.map((anchor, index) => {
                                return (
                                    <HashLink key={index} smooth to={anchor.hashLocation} className="pageAnchorItem">
                                        <DropdownItem>{anchor.displayName}</DropdownItem>
                                    </HashLink>
                                );
                            })}
                        </DropdownMenu>
                    </Dropdown>
                </Col>
                {props.children}
            </Row>
        </div>
    )
};
